import { render } from "./Register.vue?vue&type=template&id=328663d8&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-328663d8"

export default script